/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import parse from 'html-react-parser';
import './Disclaimer.css';

const Disclaimer = ({ data }) => {
  if (!data) return null;

  return (
    <section className="disclaimer-section ">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {data.title && <h3 className="disclaimer-title mb-3">{data.title}</h3>}
            <div className="disclaimer-content">
              {data.items && data.items.map((item, index) => (
                <div key={index} className="disclaimer-item mb-2">
                  {parse(item)}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;